// src/phase4/data/enemy-configs.ts
// Enemy type configuration data

import { EnemyType, EnemyTypeConfig } from '../types/enemy';

// Enemy configurations per GDD-MVP design
export const ENEMY_CONFIGS: Record<string, EnemyTypeConfig> = {
  [EnemyType.SQL_INJECTION]: {
    type: EnemyType.SQL_INJECTION,
    name: 'SQL Injection',
    baseHp: 60,
    baseSpeed: 0.003,
    bounty: 15,
    size: 24,
    textureKey: 'enemy_sql',
  },
  [EnemyType.XSS_ATTACK]: {
    type: EnemyType.XSS_ATTACK,
    name: 'XSS Attack',
    baseHp: 100,
    baseSpeed: 0.0025,
    bounty: 20,
    size: 24,
    textureKey: 'enemy_xss',
  },
  [EnemyType.DDOS_BOT]: {
    type: EnemyType.DDOS_BOT,
    name: 'DDoS Bot',
    baseHp: 180,
    baseSpeed: 0.0015,
    bounty: 30,
    size: 24,
    specialAbility: {
      type: 'shield',
      triggerHpPercent: 0.3,
      effectValue: 50,
    },
    textureKey: 'enemy_ddos',
  },
  [EnemyType.TROJAN]: {
    type: EnemyType.TROJAN,
    name: 'Trojan',
    baseHp: 120,
    baseSpeed: 0.002,
    bounty: 35,
    size: 24,
    specialAbility: {
      type: 'stealth',
      triggerHpPercent: 0.5,
    },
    textureKey: 'enemy_trojan',
  },
  [EnemyType.ZERO_DAY]: {
    type: EnemyType.ZERO_DAY,
    name: 'Zero-Day',
    baseHp: 500,
    baseSpeed: 0.001,
    bounty: 100,
    size: 24,
    specialAbility: {
      type: 'spawn_clone',
      triggerHpPercent: 0.5,
      effectValue: 2, // Spawns 2 clones
    },
    textureKey: 'enemy_zero_day',
  },
};

// Helper to get enemy config with difficulty scaling
export function getEnemyConfigWithDifficulty(
  type: string,
  difficultyMultiplier: number
): EnemyTypeConfig {
  const config = ENEMY_CONFIGS[type];
  if (!config) {
    throw new Error(`Unknown enemy type: ${type}`);
  }

  return {
    ...config,
    baseHp: Math.floor(config.baseHp * difficultyMultiplier),
    bounty: Math.floor(config.bounty * difficultyMultiplier),
  };
}

// Export all enemy configs as array
export const ALL_ENEMY_CONFIGS = Object.values(ENEMY_CONFIGS);
